export function getProgressPercent(completed: number, total: number): number {
  if (total <= 0 || completed <= 0) return 0;
  const percent = (completed / total) * 100;
  return Math.round(percent);
}
